import React, { useRef } from 'react';
import {
  ImageBackground, Pressable, StyleSheet, Text, View, ScrollView,
} from 'react-native';
import CardFlip from 'react-native-card-flip';
import PropTypes from 'prop-types';
import APMStyles from '../styles';
import GradientButton from './GradientButton';

function ExerciseCard(props) {
  const {
    backgroundImg, title, subtitle, watchVideo, description,
  } = props;
  const cardFlip = useRef();

  return (
    <View style={styles.container}>
      <CardFlip ref={cardFlip} flipZoom={0} perspective={0} style={styles.cardContainer}>
        <Pressable
          style={styles.card}
          onPress={() => cardFlip.current.flip()}
        >
          <ImageBackground source={backgroundImg} style={styles.backgroundImage}>
            <View style={styles.backgroundOverlay}>
              <View style={styles.titleContainer}>
                <Text style={styles.title}>{title.toUpperCase()}</Text>
                <Text style={styles.subtitle}>{subtitle.toUpperCase()}</Text>
              </View>
            </View>
          </ImageBackground>
        </Pressable>

        <Pressable
          style={styles.card}
          onPress={() => cardFlip.current.flip()}
        >
          <View style={styles.textContainer}>
            <ScrollView contentContainerStyle={styles.scrollViewContainer}>
              <Text style={styles.text}>{description}</Text>
            </ScrollView>
          </View>
        </Pressable>
      </CardFlip>

      <GradientButton
        outline
        icon="play-circle-outline"
        onPress={watchVideo}
      >
        WATCH VIDEO
      </GradientButton>
    </View>
  );
}

ExerciseCard.defaultProps = {
  backgroundImg: undefined,
  title: '',
  subtitle: '',
  watchVideo: () => {},
  description: PropTypes.string,
};

ExerciseCard.propTypes = {
  backgroundImg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  watchVideo: PropTypes.func,
  description: PropTypes.string,
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: '10%',
    paddingVertical: 10,
  },
  cardContainer: {
    height: 250,
    marginBottom: 5,
  },
  card: {
    height: 250,
    borderRadius: 10,
    backgroundColor: APMStyles.colors.accent1,
    overflow: 'hidden', // rounds background img
  },
  backgroundImage: {
    flex: 1,
  },
  backgroundOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  titleContainer: {
    paddingTop: 10,
    paddingLeft: 10,
  },
  title: {
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
  },
  subtitle: {
    color: APMStyles.colors.text,
    paddingTop: 5,
  },
  textContainer: {
    flex: 1,
    padding: 10,
  },
  scrollViewContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  text: {
    color: 'white',
  },
});

export default ExerciseCard;
